import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { addCalendarDays, londonToday } from 'lib/dayjs'

import IndentedRadioGroup from 'components/form/indented-radio-group'
import { FilterValues } from 'hooks/useSearchParamManager'
import { IndexableKey } from 'utils/types/indexable-key'

type SupportedFields = 'lastActivityAt'

const LastActivityFilter = <T,>({ name }: { name: SupportedFields }) => {
  const { setFieldValue, values } = useFormikContext<FilterValues<T>>()
  const filter = values[name as IndexableKey<T>]
  let option: string | undefined

  if (typeof filter === 'object' && 'option' in filter) {
    option = filter.option
  }

  useEffect(() => {
    if (option === 'any') {
      setFieldValue(`${name}.gte`, '')
      setFieldValue(`${name}.lte`, '')
    }

    if (option === 'last7Days') {
      setFieldValue(`${name}.gte`, addCalendarDays(londonToday(), -7))
      setFieldValue(`${name}.lte`, 'tomorrow')
    }

    if (option === 'moreThan7Days') {
      setFieldValue(`${name}.gte`, '2019-01-01')
      setFieldValue(`${name}.lte`, addCalendarDays(londonToday(), -7))
    }
  }, [name, option, values, setFieldValue])

  return (
    <IndentedRadioGroup
      name={`${name}.option`}
      options={[
        { value: 'any', label: 'Any' },
        { value: 'last7Days', label: 'Within last 7 days' },
        { value: 'moreThan7Days', label: '7+ days' },
      ]}
    />
  )
}

export default LastActivityFilter
